// Task 7: Scheduled Jobs registry — Settings panel client.
//
// Calls /api/admin/jobs via the CSG Gateway (NOT direct to agent-backend), same posture as
// settingsApi.js: the gateway's /api/admin/jobs* proxy injects its own X-API-Key server-side so
// agent-backend's admin-key gate is satisfied — the SPA never holds that key.
//
// URL note: gatewayClient's baseURL is VITE_CSG_GATEWAY_URL (which is "/api" in prod), so
// gatewayClient.get("/api/admin/jobs") produces "/api/api/admin/jobs". That double prefix is
// correct and intentional in this codebase (Traefik strips one) — see settingsApi.js and
// VITE_OCR_URL=/api/api/ocr for the same pattern. Do not "fix" it.
import gatewayClient from "../../services/api/gateway.js";

const BASE = "/api/admin/jobs";

export const jobsApi = {
  getJobs: async () => (await gatewayClient.get(BASE)).data,
  triggerJob: async (key) =>
    (await gatewayClient.post(`${BASE}/${key}/trigger`)).data,
};
